export const getPlainTextFromHtml = (html: string) => {
  if (!html) return '';

  const div = document.createElement('div');
  div.innerHTML = html;

  return (
    div.textContent
      ?.replace(/\u200B/g, '')
      .replace(/\s+/g, ' ')
      .trim() ?? ''
  );
};
